<template>
    <div class="guide"
         :style="
            'padding: 5px ' + item.lrEdge.val + 'px;' +
            'margin-top:' + item.mbConfig.val +'px;'
         "
    >
        <div class="line" :style="'border-bottom: ' + item.heightConfig.val + 'px ' + item.lineStyle.list[item.lineStyle.type].style + '' + item.lineColor.color[0].item"></div>
    </div>
</template>

<script>
export default {
    props:{
        item:{
            type:Object,
            default:{}
        }
    },
    data(){
        return{

        }
    }
}
</script>

<style scoped lang="scss">
.guide {
    width: 100%;
    margin-top: 10px;
    padding: 5px 10px;
    .line{
        width: 100%;
    }
}
</style>